export enum WIDGET_LEGACY_POST_LIST {
    /**
     * @value Shared with
     * @description Community posts can be shared with other communities. In several contexts we want to list the communities the post is shared with. (c.f. screenshots)
     */
    SHARED_WITH = 'FRONT.COMMUNITY.POST.SHARED_WITH',
}
